import { FC, ReactElement } from 'react';
import styled from '@emotion/styled';
import TopBar from '../connected/TopBar';

type Props = {
  children: ReactElement<any>;
  className?: string;
};

const CommentBoardLayout: FC<Props> = ({ children, className }) => {
  return (
    <Root className={className}>
      <TopBar />
      <Content>{children}</Content>
    </Root>
  );
};

const Root = styled('div')({
  height: '100%',
});

const Content = styled.main((props) => ({
  height: '100%',
  paddingTop: props.style ? props.style.paddingTop : undefined,
}));

export default CommentBoardLayout;
